import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { neutral } from "@flat-ui";
import { Grid2 } from "@mui/material";
import { ForbiddenPage } from "@pages/forbidden-page";

/**
 * Page shown when a user tries to access a resource they don't have access to.
 * Displays the ForbiddenPage within a minimal layout (no sidebar, breadcrumbs, or searchbar).
 */
export function ForbiddenAccessPage(): JSX.Element {
  return (
    <Grid2
      container
      sx={{
        minHeight: "100vh",
        backgroundColor: neutral[50],
        position: "relative",
        overflow: "hidden",
      }}
    >
      <MainPageLayout
        shouldShowSidebar={false}
        shouldShowLogo={true}
        shouldHideOpenButton={true}
        shouldShowBreadcrumbs={false}
        shouldShowSearchbar={false}
        topbarBackgroundColor={neutral[50]}
      >
        <Grid2 container sx={{ marginTop: "55px" }}>
          <ForbiddenPage />
        </Grid2>
      </MainPageLayout>
    </Grid2>
  );
}
